(ns common.endpoints.mcp-enablement
  "Shared Malli :in/:out models for the endpoint that records the acceptance of
   the MCP terms and activates MCP modules for a tenant
   (backend.domain.mcp-enablement). Request schemas describe the RPC :body;
   responses are wrapped in {:body ...}."
  (:require
   [common.modules :as modules]))

(def terms-version
  "Version of the MCP terms text (the :settings/mcp-terms-* keys in
   common.localization-en). Raise it when the text changes. The backend writes
   the version into the audit record, and refuses a request that names an
   older version. A test in backend.domain.mcp-enablement-test pins a hash of
   the text for each version. It fails when the text changes without a new
   version."
  1)

(def accept-terms-request
  [:map
   [:modules [:vector {:min 1} (into [:enum] (sort modules/mcp-connector-modules))]]
   [:accepted? [:= true]]
   [:terms-version int?]])

(def accept-terms-response
  [:map
   [:body
    [:map
     [:modules [:set keyword?]]]]])
